export type User = {
    email: string,
    userName: string
}

export function isLoggedIn(): boolean {
    const token = localStorage.getItem("token");
    return token !== null;
}